<template>
  <div>
    <v-btn class="red-button mt-2 d-flex" @click="getGlossary">
      Glosario de motivos de rechazo
    </v-btn>
    <v-dialog v-model="glossary.modal" width="50%">
      <modal-bar
        title="Glosario de motivos de rechazo"
        @onClose="glossary.modal = false"
      />
      <v-card>
        <v-card-text class="pt-6">
          <v-progress-linear
            v-if="glossary.loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>
          <div v-else>
            <v-row
              v-for="(column, colIndex) in rejectionColumns"
              :key="colIndex"
              no-gutters
            >
              <v-col
                v-for="(item, index) in column"
                :key="index"
                cols="6"
                class="text-left"
                :class="{ 'font-weigth-bold': item.color }"
                :style="`color: ${item.color}`"
              >
                {{ item.code }} {{ item.description }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-left">
                <b>Colorometría</b> <br />
                <span
                  v-for="(item, index) in glossary.colorimetry"
                  :key="index"
                  class="justufy-center d-flex align-center"
                  :style="`color: ${item.color}`"
                >
                  <v-icon small class="mr-1" :color="item.color"
                    >mdi-circle</v-icon
                  >
                  {{ item.label }}</span
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script scoped>
  import ModalBar from '@/components/modals/ModalBar.vue';
  import axios from '@/plugins/axios';

  export default {
    name: 'OrderRejectionGlossaryModal',
    components: {
      ModalBar,
    },
    data() {
      return {
        glossary: {
          data: [],
          colorimetry: [],
          loading: false,
          modal: false,
        },
      };
    },
    computed: {
      rejectionColumns() {
        const middle = Math.ceil(this.glossary.data.length / 2);
        return [
          this.glossary.data.slice(0, middle),
          this.glossary.data.slice(middle),
        ];
      },
    },
    methods: {
      async getGlossary() {
        this.glossary.loading = true;
        this.glossary.modal = true;
        try {
          const res = await axios.get('/order-management/glossary');
          this.glossary.data = res.data.data;
          this.glossary.colorimetry = res.data.colorimetry;
        } catch (error) {
          this.$toast.error(
            'Error al obtener el glosario de motivos de rechazo'
          );
          this.glossary.data = [];
          this.glossary.modal = false;
        }
        this.glossary.loading = false;
      },
    },
  };
</script>
